export const formatBrandName = (brand: string) => {
  const brandNames = {
    'American Express': 'Amex',
    'Diners Club': 'Diners',
  };

  return brandNames[brand] ? brandNames[brand] : brand;
};

export const formatPhoneNumber = (phoneNumberString: string) => {
  let cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  if (cleaned.startsWith('1')) {
    cleaned = cleaned.substring(1);
  }
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return null;
};

export const returnCardImage = (cardBrand: string) => {
  const cardImages = {
    Visa: <img src="/public/new_card_visa.svg" alt="" />,
    UnionPay: <img src="/public/new_card_generic.svg" alt="" />,
    Amex: <img src="/public/new_card_amex.svg" alt="" />,
    JCB: <img src="/public/new_card_generic.svg" alt="" />,
    Discover: <img src="/public/new_card_generic.svg" alt="" />,
    Diners: <img src="/public/new_card_generic.svg" alt="" />,
    MasterCard: <img src="/public/new_card_mastercard.svg" alt="" />,
    Error: <img src="/public/stp_card_error@3x.png" alt="" />,
    Unknown: <img src="/public/stp_card_unknown@3x.png" alt="" />,
  };

  return cardImages[formatBrandName(cardBrand)] ? cardImages[formatBrandName(cardBrand)] : cardImages.Unknown;
};
